import ApiService from "../service/apiService";
import API from "../config/api";

export default {
  state: {
    allMessageTemplates: []
  },
  mutations: {
    SET_ALL_MESSAGE_TEMPLATES(state, payload) {
      state.allMessageTemplates = payload;
    }
  },
  getters: {
    getAllMessageTemplates(state) {
      return state.allMessageTemplates;
    }
  },
  actions: {
    async loadAllMessageTemplates(context) {
      try {
        let res = await ApiService.get(API.endpoints.GET_MESSAGE_TEMPLATES);
        context.commit("SET_ALL_MESSAGE_TEMPLATES", res.data.data.map((data, idx) => {
          data['idx'] = idx + 1;
          return data;
        }));
      } catch (e) {
        let error = await context.dispatch("handleHttpErrorResponse", e.response, {root: true});
        await context.dispatch("addFlashMessages", [{message: error, type: "danger"}], {root:true});
      }
    },
    async getOrLoadMessageTemplates(context) {
      if (context.state.allMessageTemplates.length === 0) {
        await context.dispatch("loadAllMessageTemplates");
      }
      return context.state.allMessageTemplates;
    }
  },
};
